import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeriodLookupComponent } from './period-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [PeriodLookupComponent],
  exports: [PeriodLookupComponent]
})
export class PeriodLookupModule { }
